module.exports = __webpack_public_path__ + "a720606720b67ef4aeb8901b44fc0782.svg";